import { Button, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { useAcompanhamentoUltimosContatosQuery, useInformacoesPuerperioQuery } from 'graphql/hooks.generated'
import { FonteIdadeGestacionalEnum, Sort, TipoAcompanhamentoEnum } from 'graphql/types.generated'
import { useHistory } from 'react-router'
import { GRUPO_CBO_ACOMP_PRE_NATAL_E_PUERPERIO } from 'types/NivelCbo'
import { calculateIdadeGestacional } from 'util/atendimento/gestante/calculateIdadeGestacional'
import { formatDate, toDate } from 'util/date/formatDate'
import { ACOMPANHAMENTOS_PUERPERIO_URL } from 'view/atendimentos/detail/acompanhamentos/getAcompanhamentosSideMenuItems'
import { useAcompanhamentoPuerperio } from 'view/atendimentos/detail/acompanhamentos/puerperio/hooks/useAcompanhamentoPuerperio'
import { getFiltrosConsultasPorAcompanhamento } from 'view/atendimentos/detail/acompanhamentos/util/util-acompanhamentos'

import { formatIdadeGestacional } from '../../pre-natal/util-preNatal'
import { ContentCardSection } from '../components/ContentCardSection'

interface PuerperioCardProps {
  prontuarioId: ID
  cidadaoId: ID
  atendimentoId: ID
  dataReferencia: Instant
}

export function PuerperioCard(props: Readonly<PuerperioCardProps>) {
  const { prontuarioId, cidadaoId, atendimentoId, dataReferencia } = props

  const history = useHistory()

  const { data, loading } = useInformacoesPuerperioQuery({
    variables: { prontuarioId },
    skip: !prontuarioId,
    fetchPolicy: 'cache-first',
  })

  const informacoesPuerperio = data?.informacoesPuerperio
  const { data: puerperio } = useAcompanhamentoPuerperio(prontuarioId, dataReferencia)
  const dataInicioPuerperio = puerperio?.duracaoPuerperio?.startDate

  const filtroConsultasPuerperio = getFiltrosConsultasPorAcompanhamento(TipoAcompanhamentoEnum.PUERPERIO)

  const { data: consultasPuerperio, loading: loadingConsultas } = useAcompanhamentoUltimosContatosQuery({
    variables: {
      input: {
        cidadaoId,
        somenteMeusRegistros: false,
        sortDirection: Sort.DESC,
        tiposRegistro: filtroConsultasPuerperio.tiposRegistro,
        excludeEscutaOrPreAtendimentoFromAtendProf: atendimentoId,
        pageParams: {
          size: 1,
        },
        filtrosAvancados: {
          periodo: { startDate: dataInicioPuerperio, endDate: puerperio?.duracaoPuerperio?.endDate },
          cod2002Cbos: [...GRUPO_CBO_ACOMP_PRE_NATAL_E_PUERPERIO],
          exibirRegistrosInativos: false,
          codCiaps2: filtroConsultasPuerperio.codCiaps2,
          codCids10: filtroConsultasPuerperio.codCids10,
        },
      },
    },
    skip: !cidadaoId || !dataInicioPuerperio,
    fetchPolicy: 'cache-first',
  })

  const handleAcompanhamentoButtonClick = () => {
    history.push(`${ACOMPANHAMENTOS_PUERPERIO_URL}?redirect=puerperio`)
  }

  const dataDesfecho = informacoesPuerperio?.preNatal?.dataDesfecho
  const isFonteIgDum = informacoesPuerperio?.preNatal?.fonteIdadeGestacional === FonteIdadeGestacionalEnum.DUM
  const igParto = dataDesfecho
    ? calculateIdadeGestacional(toDate(informacoesPuerperio?.dataInicioGestacao), toDate(dataDesfecho))
    : null
  const dataUltimaConsulta = consultasPuerperio?.historico?.content.first()?.dataAtendimento

  return (
    <ContentCardSection isLoading={loading || loadingConsultas} messageLoading='Carregando dados do puerpério'>
      <VFlow vSpacing={0.5}>
        <HLabel title='Data do desfecho:'>{formatDate(dataDesfecho)}</HLabel>
        <HLabel title={`IG parto (${isFonteIgDum ? 'DUM' : 'eco. obst.'}):`}>
          {igParto?.emDias && formatIdadeGestacional(igParto?.emDias)}
        </HLabel>
        <HLabel title='Tipo de gravidez:'>{informacoesPuerperio?.preNatal?.tipoGravidez?.descricao}</HLabel>
        <HLabel title='Risco da gestação:'>{informacoesPuerperio?.preNatal?.altoRisco ? 'Alto' : 'Habitual'}</HLabel>
        <HLabel title='Última consulta:'>{formatDate(dataUltimaConsulta)}</HLabel>
        <Button kind='primary' size='small' skin='outline' block onClick={handleAcompanhamentoButtonClick}>
          Ver acompanhamento
        </Button>
      </VFlow>
    </ContentCardSection>
  )
}
